module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.31173",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.5208",
      "atom": "static-1.5570",
      "client-types": "static-1.512",
      "conversations-error-reporting": "static-1.9323",
      "conversations-internal-pub-sub": "static-1.16494",
      "conversations-internal-schema": "static-1.13660",
      "conversations-message-history": "static-1.13758",
      "conversations-test-sdk": "static-1.10934",
      "conversations-visitor-experience-components": "static-1.24536",
      "data-fetching-client": "static-1.10137",
      "head-dlb": "static-1.5330",
      "hs-promise-utils": "static-1.6090",
      "hs-test-utils": "static-1.8537",
      "hubspot-dlb": "static-2.1911",
      "HubStyleTokens": "static-2.11985",
      "I18n": "static-7.1715",
      "immer": "static-1.107",
      "jasmine-immutable": "static-1.3435",
      "jasmine-runner": "static-1.6951",
      "quartz": "static-1.7693",
      "react-dlb": "static-1.96",
      "react-select-plus": "static-1.120",
      "react-transition-group": "static-2.80",
      "redux-thunk": "static-2.86",
      "reselect": "static-3.18",
      "sanitize": "static-1.4971",
      "StyleGuideUI": "static-3.520",
      "transmute": "static-2.97",
      "urlinator": "static-1.5012",
      "usage-tracker": "static-1.7821",
      "usage-tracker-core": "static-1.7671",
      "usage-tracker-public": "static-1.7632",
      "viral-links-lib": "static-1.7582",
      "visitor-ui-component-library": "static-1.6656",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5315",
      "conversations-visitor-message-history": "static-1.23273",
      "cssUtils": "static-1.1121",
      "enviro": "static-4.523",
      "flux-actions": "static-1.383",
      "foundations-components": "static-1.8784",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6704",
      "interactive-cards": "static-1.579",
      "hubspot-url-utils": "static-1.4383",
      "immutable": "static-2.88",
      "metrics-js": "static-1.9990",
      "PatternValidationJS": "static-1.3381",
      "PortalIdParser": "static-2.458",
      "pulse": "static-1.1149",
      "raven": "static-3.6411",
      "react": "static-7.204",
      "react-aria": "static-1.79",
      "react-dom": "static-7.85",
      "react-redux": "static-7.80",
      "react-rhumb": "static-1.17238",
      "react-utils": "static-2.5677",
      "redux": "static-4.81",
      "rpc-client-utils": "static-1.5165",
      "redux-toolkit": "static-1.84",
      "sanitize-text": "static-1.8656",
      "signup-constants": "static-1.19987",
      "styled-components": "static-2.100",
      "usage-tracker-multi": "static-1.6235",
      "visitor-ui-component-library-icons": "static-1.6467",
      "hs-promise-rejection-tracking": "static-1.6078",
      "raven-hubspot": "static-1.6718",
      "hoist-non-react-statics": "static-3.9",
      "moment": "static-3.75",
      "quartz-config": "static-1.1471",
      "quartz-core": "static-1.6912",
      "foundations-assets": "static-1.5388",
      "foundations-theming": "static-1.4988",
      "UIComponents": "static-3.8931",
      "conversations-async-data": "static-2.8159",
      "customer-data-email": "static-1.18677",
      "cv-backend-services": "static-1.1607",
      "immutable-less": "static-1.5150",
      "conversations-skeleton-state": "static-1.7617",
      "crm-events-viz-core": "static-1.34516",
      "customer-data-objects": "static-1.8208",
      "icons": "static-2.708",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.1049",
      "ui-images": "static-2.1282",
      "apollo-stack-hubspot": "static-3.101",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.95",
      "HeadJS": "static-2.829",
      "framer-motion": "static-1.86",
      "hs-test-utils-bend-plugin": "static-1.3648",
      "msw": "static-1.105",
      "msw-config": "static-1.35",
      "testing-library": "static-1.167",
      "i18n-data": "static-1.237",
      "moment-timezone": "static-5.98",
      "jasmine": "static-4.4804",
      "signup-ui-url-generator": "static-2.8536",
      "quartz-i18n": "static-1.1368",
      "sassPrefix": "static-1.386",
      "bend-plugin-foundations-components": "static-1.5053",
      "floating-ui": "static-1.70",
      "foundations-theming-specialty": "static-1.2704",
      "hs-story-utils": "static-1.9927",
      "react-create-root-preference": "static-1.111",
      "react-virtualized": "static-2.114",
      "tanstack-table": "static-1.68",
      "trellis-assets": "static-1.3147",
      "ui-fonts": "static-1.1247",
      "hs-locale-management": "static-1.414",
      "dompurify": "static-1.15",
      "utility-belt": "static-1.3036",
      "batch-promise": "static-1.2048",
      "bend-plugin-pulse": "static-1.652",
      "chirp-fetch": "static-1.2403",
      "event-emitter": "static-1.1460",
      "fast-json-patch": "static-1.76",
      "hub-http-janus": "static-1.913",
      "quick-fetch": "static-1.4243",
      "csstype": "static-1.50",
      "beacon-keepalive-queue": "static-1.198",
      "quartz-head": "static-1.1358",
      "web-vitals": "static-1.21",
      "bend-plugin-chirp-manifest": "static-1.575",
      "quartz-routing": "static-1.1123",
      "usage-tracker-anonymous": "static-1.6238",
      "opentelemetry-fe-types": "static-1.290",
      "dispatcher": "static-1.150",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4987",
      "mobile-manifest-mixins": "static-1.612",
      "module-federation": "static-1.42",
      "opentelemetry-fe": "static-1.665",
      "quartz-auth": "static-1.1368",
      "quartz-test": "static-1.1368",
      "quartz-tracking": "static-1.1072",
      "trellis-components": "static-1.3166",
      "usage-tracker-container": "static-1.7811",
      "bend-plugin-foundations-theming": "static-1.3471",
      "foundations-theming-base": "static-1.3973",
      "stylex": "static-1.48",
      "HubStyle": "static-2.12292",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5087",
      "customer-data-ui-utilities": "static-1.10330",
      "FileManagerCore": "static-1.40377",
      "FileManagerLib": "static-1.40518",
      "hubspot-apollo-client": "static-1.5381",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.756",
      "timezone-utils": "static-2.5729",
      "ui-gdpr-components": "static-1.10658",
      "ts-schema": "static-1.4407",
      "ai-components-ui-library": "static-1.10064",
      "avatar-components": "static-1.2987",
      "content-assistance-lib": "static-1.8455",
      "crm-component-utils": "static-1.40250",
      "crm-display-components": "static-1.26000",
      "crm-fe-perf": "static-1.23398",
      "crm-links": "static-1.6812",
      "crm-message-bus": "static-1.44153",
      "crm-search-service-types": "static-1.1631",
      "crm-source-interpretation-lib": "static-1.5829",
      "customer-data-communicator": "static-1.46664",
      "customer-data-filters-ui": "static-1.41439",
      "customer-data-objects-ui-components": "static-1.13534",
      "customer-data-properties": "static-1.53125",
      "customer-data-rte": "static-1.33939",
      "draft-plugins": "static-2.22394",
      "file-manager-components": "static-1.24878",
      "framework-data-schema-resolvers": "static-1.7392",
      "frontend-preferences-client": "static-1.8420",
      "hs-resources": "static-1.683",
      "hubspot-prosemirror": "static-1.19321",
      "object-comments-thread-lib": "static-1.11680",
      "prosemirror-user-and-team-at-mentions": "static-1.1465",
      "reference-resolvers-lite": "static-1.8612",
      "trellis-theming": "static-1.1515",
      "ui-addon-upgrades": "static-9.18561",
      "universal-associations-select": "static-1.11596",
      "universal-record-utils-lib": "static-1.2411",
      "wootric-nps": "static-1.7310",
      "inbound-db-properties-service-client": "static-1.4163",
      "property-translator": "static-1.5879",
      "segments-query-core": "static-1.1929",
      "bender-build-tools": "static-1.3615",
      "stylex-utils": "static-1.182",
      "opentelemetry-web": "static-1.25",
      "hub-http-shared-msw-handlers": "static-1.10940",
      "hubspotter-http-shared-msw-handlers": "static-1.10938",
      "usage-tracker-session-replay": "static-1.5507",
      "base-ui": "static-1.31",
      "react-day-picker": "static-1.17",
      "tanstack-virtual": "static-1.45",
      "react-dnd-compat": "static-1.5109",
      "audio-components": "static-1.6605",
      "breeze-artifacts-sdk": "static-1.1063",
      "ContentUtils": "static-1.69529",
      "copilot-toolkit": "static-1.12193",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.30094",
      "FileManagerImages": "static-1.38029",
      "foundations-components-legacy": "static-1.1809",
      "html-to-image": "static-1.67",
      "immerable": "static-1.4641",
      "react-colorpicker": "static-2.10708",
      "ui-universal-auth": "static-1.9785",
      "video-components": "static-1.14489",
      "video-data-lib": "static-1.36145",
      "video-embed": "static-1.36979",
      "hubspot-apollo-cache": "static-1.840",
      "chatspot-core": "static-1.24010",
      "trellis-migration-context": "static-1.77",
      "superstore": "static-1.5256",
      "ui-addon-video-player": "static-1.9122",
      "ui-coaching-tips": "static-1.29607",
      "commerce-subscription-lib": "static-1.38096",
      "crm-actions": "static-1.6884",
      "crm-cards-sdk": "static-1.45072",
      "customer-data-properties-shared-msw-handlers": "static-1.10267",
      "customer-data-tracking": "static-1.7371",
      "inbound-db-meta-service-client": "static-1.3787",
      "framework-data-table": "static-2.12878",
      "location-customization-utils-lib": "static-1.10465",
      "restore-request-side-panel-lib": "static-1.2078",
      "calling-error-reporting": "static-1.31828",
      "calling-internal-common": "static-1.31821",
      "calling-usage-tracker": "static-1.7039",
      "crm_data": "static-4.93253",
      "customer-data-content": "static-1.28077",
      "draft-content-plugins": "static-1.29194",
      "draft-convert": "static-2.86",
      "draft-extend": "static-3.90",
      "draft-js": "static-5.92",
      "draft-signature-plugin": "static-1.24919",
      "EmailSignatureEditor": "static-1.25286",
      "hubspot-prosemirror-plugins": "static-1.19313",
      "integration-settings-components": "static-1.16520",
      "integrations-lib": "static-1.17480",
      "integrations-tracking-lib": "static-1.6122",
      "laboratory-lib": "static-3.7645",
      "native-integrations-shared-strings": "static-1.8261",
      "nav-meta": "static-1.30853",
      "onboarding-scopes": "static-1.6952",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12644",
      "quotes-client-types": "static-1.39213",
      "reference-resolvers": "static-1.8683",
      "rich-text-lib": "static-1.20590",
      "sales-email-signature-service-client": "static-1.4347",
      "sequences-lib": "static-1.8823",
      "ui-addon-i18n": "static-1.11644",
      "ui-addon-iframeable": "static-1.9578",
      "ui-business-units-lib": "static-1.9596",
      "ui-shepherd-react": "static-3.10779",
      "user-context": "static-1.5553",
      "whatsapp-sending-lib": "static-1.7211",
      "customer-data-filters-ui-msw-helpers": "static-1.23874",
      "customer-data-property-utils": "static-1.8551",
      "customer-data-reference-ui-components": "static-1.13673",
      "events-data-lib": "static-1.746",
      "FormUrlGenerator": "static-2.5213",
      "framework-builder-read-service-client": "static-1.4348",
      "multi-account-reference-resolvers": "static-1.1511",
      "onboarding-tours": "static-1.17423",
      "reporting-datasets-permissions-lib": "static-1.14809",
      "segments-client-types": "static-1.12253",
      "SharedI18nStrings": "static-1.190",
      "ui-addon-teams": "static-1.22038",
      "calling-global-api": "static-1.66268",
      "calling-lifecycle-internal": "static-1.67650",
      "calling-lifecycle-messages": "static-1.59942",
      "commerce-products-lib": "static-1.10970",
      "conditional-properties-service-client": "static-1.4126",
      "crm-index-visualization-core": "static-1.4789",
      "crm-pipelines-api-client-types": "static-1.4456",
      "data-agent-utils": "static-1.969",
      "data-token-picker": "static-1.17170",
      "external-options-client-types": "static-1.4451",
      "formula-editor": "static-1.15041",
      "google-libphonenumber": "static-1.52",
      "inbounddb-objects-service-types": "static-1.4527",
      "meetings-icalendar-utils-lib": "static-1.1130",
      "multi-currency-client-types": "static-1.4021",
      "object-builder-ui-client": "static-1.50102",
      "pipeline-validation-client-types": "static-1.4296",
      "property-value-citations": "static-1.3739",
      "react-tinymce": "static-1.56313",
      "smart-data-capture-core": "static-1.530",
      "tiered-pricing": "static-1.2321",
      "tinymce-config": "static-2.55439",
      "tinymce-plugins": "static-1.58553",
      "tinymce-themes": "static-1.57409",
      "topics-actions-lib": "static-1.683",
      "trellis-ext-i18n": "static-1.1422",
      "trial-components-library": "static-1.14423",
      "ui-addon-emoji-picker": "static-1.10363",
      "ui-addon-form-validation": "static-1.11352",
      "zustand": "static-1.91",
      "breeze-engine-lib": "static-1.2255",
      "poll-commands": "static-1.3976",
      "video-components-external": "static-1.12487",
      "fdsr-migration-layer": "static-1.511",
      "framework-data-schema-quick-fetch": "static-1.7297",
      "persist-promise": "static-1.4205",
      "content-media-capture": "static-1.5831",
      "emoji-mart": "static-3.9",
      "growth-payments-core": "static-1.26544",
      "knowledge-content-types": "static-1.8767",
      "payment-link-components": "static-1.24503",
      "call-summary": "static-1.40956",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.11086",
      "merchandise-lib": "static-1.288",
      "purchase-motions-components": "static-1.6664",
      "crm-object-search-query-utilities": "static-1.10499",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "breeze-engine-core": "static-1.1533",
      "cms-field-types": "static-1.5309",
      "content-icons-ui": "static-1.2480",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5928",
      "magpie-types": "static-1.5388",
      "simple-logging-lib": "static-1.3550",
      "nudge-client-utils": "static-1.3454",
      "custom-vendor-connection-lib": "static-1.349",
      "unified-auth-core-lib": "static-1.1581",
      "social-insights-client-types": "static-1.22970",
      "outpost": "static-1.4628",
      "markdown-it": "static-1.6",
      "growth-onboarding-feedback-components": "static-1.7080",
      "commerce-billing-lib": "static-1.20534",
      "commerce-shared-components-lib": "static-1.19617",
      "commerce-tools-ui-lib": "static-1.11363",
      "crm-activity-creator-data": "static-1.47793",
      "customer-data-associations": "static-1.7837",
      "reporting-data": "static-1.69435",
      "tasks-actions-lib": "static-1.476",
      "ui-addon-draggable": "static-3.5250",
      "crm-record-cards-service-types": "static-1.3874",
      "crm_universal": "static-1.22760",
      "SalesContentIndexUI": "static-3.9771",
      "content-embed-lib": "static-1.7843",
      "data-model-builder-lib": "static-1.13539",
      "remote-dom": "static-1.11",
      "remote-ui": "static-1.78",
      "ui-components-test-utils": "static-1.6122",
      "ui-extensions-remote-renderer": "static-1.18301",
      "universal-page-editor-lib": "static-1.3512",
      "integrations-error-boundary-lib": "static-1.14895",
      "redux-observable": "static-1.81",
      "ReduxMessenger": "static-2.10869",
      "rxjs": "static-5.10",
      "ai-addon-copilot-preview": "static-1.9276",
      "sequences-client-types-lib": "static-1.8680",
      "foundations-components-test-utils": "static-1.6267",
      "navigation-messaging": "static-1.8543",
      "getting-started-shared-tasks": "static-1.19604",
      "getting-started-shared-tasks-store": "static-1.18722",
      "onboarding-tours-utils": "static-1.1490",
      "marketing-platform-lib": "static-1.7405",
      "messaging-usage-based-billing-components-lib": "static-1.2362",
      "whatsapp-management-lib": "static-1.10370",
      "growth-data-modal": "static-1.6168",
      "growth-onboarding-confetti": "static-1.3557",
      "growth-onboarding-next-action-utils": "static-1.3025",
      "navigation-components": "static-1.19216",
      "nest": "static-1.735",
      "onboarding-tours-client": "static-1.5638",
      "ui-shepherd-tracker": "static-1.8160",
      "crm-index-associations-lib": "static-1.6947",
      "shared-worker-versioning": "static-1.11542",
      "voice-sms-access-library": "static-1.2524",
      "commerce-permissions": "static-1.1286",
      "products-iframe-lib": "static-1.8958",
      "products-ui-components-shared-msw-handlers": "static-1.11322",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11023",
      "sales-views-client-types": "static-1.4757",
      "data-agent-kit": "static-1.956",
      "enrichment-settings-lib": "static-1.290",
      "fsm": "static-1.4256",
      "policy-lib": "static-1.7303",
      "bark-lib": "static-1.17033",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.108",
      "crm-properties-common-lib": "static-1.6396",
      "react-codemirror": "static-1.11141",
      "tinymce": "static-5.11",
      "hub-http-contrib": "static-1.3531",
      "interframe": "static-3.5241",
      "tinymce-data": "static-1.41524",
      "ui-addon-sales-email": "static-1.5701",
      "layout-dnd-components": "static-1.13263",
      "layout-dnd-utils": "static-1.12238",
      "ui-brand-identity-lib": "static-1.17002",
      "NamespacedHubStyle": "static-2.9380",
      "embedded-academy-lib": "static-1.16077",
      "hubs-service-types": "static-1.1766",
      "purchase-motions-api": "static-1.6667",
      "breeze-engine-chat-components": "static-1.1233",
      "highlight.js": "static-1.92",
      "content-media-composition-data-lib": "static-1.13635",
      "content-media-compositions": "static-2.17642",
      "idb-keyval": "static-1.57",
      "media-bridge-lib": "static-1.19676",
      "fix-webm-duration": "static-1.36",
      "notification-sounds": "static-1.4928",
      "seat-types-lib": "static-1.1086",
      "ui-addon-opt": "static-4.8916",
      "commerce-tours-lib": "static-1.6895",
      "growth-onboarding-reliability": "static-1.5582",
      "sales-checkout-service-client": "static-1.4020",
      "calling-cross-tab-library": "static-1.19802",
      "calling-lifecycle-usage-tracker": "static-1.9707",
      "custom-summary-templates": "static-1.159",
      "reactive-lib": "static-1.1219",
      "nudge-custom-function-registry": "static-1.3211",
      "nudge-renderer-utils": "static-1.3530",
      "whisper-core-api": "static-1.7675",
      "payments-enrollment-embed-lib": "static-1.24277",
      "stripe-embedded-components": "static-1.8283",
      "growth-onboarding-empty-states": "static-1.6571",
      "InboxConnectUtils": "static-4.15881",
      "payments-post-enroll-local-storage-lib": "static-1.5605",
      "qrcode-generator": "static-1.82",
      "meetings-rte-lib": "static-1.579",
      "reporting-client-types": "static-1.2858",
      "react-flip-move": "static-1.85",
      "FireAlarmUi": "static-1.4888",
      "sales-templates-service-types-lib": "static-1.4496",
      "ui-asset-management-lib": "static-1.11601",
      "apps-service-types": "static-1.4108",
      "association-settings-lib": "static-1.11343",
      "collaboration-sidebar": "static-1.59107",
      "conditional-property-settings-components": "static-1.620",
      "conditional-property-settings-modal": "static-1.13531",
      "data-model-actions-lib": "static-1.1961",
      "data-model-commons-lib": "static-1.13720",
      "ExportDialog": "static-6.10872",
      "final-form": "static-1.85",
      "property-management-iframe": "static-1.14505",
      "property-usages-lib": "static-1.6033",
      "reactflow": "static-1.78",
      "simple-data-table": "static-1.3859",
      "used-in-list-lib": "static-1.7476",
      "visual-association": "static-1.6400",
      "highcharts": "static-8.117",
      "reporting-visualizations": "static-1.61509",
      "ui-extensibility-client-types": "static-1.4413",
      "crm-record-cards-client": "static-1.101",
      "ai-rendering-library": "static-1.11444",
      "ai-settings-ui-library": "static-1.8628",
      "breeze-engine-ui-devtools": "static-1.629",
      "copilot-plugins": "static-1.12165",
      "messaging-shared-utils-lib": "static-1.1811",
      "messaging-user-info-utils-lib": "static-1.1981",
      "usage-based-billing-components-lib": "static-1.10844",
      "content-whatsapp-service-types": "static-1.701",
      "short-messages-app-service-client": "static-1.4418",
      "ui-tool-access": "static-1.10657",
      "onboarding-data-sync-lib": "static-1.2871",
      "growth-onboarding-next-action-components": "static-1.3053",
      "user-context-client": "static-1.5008",
      "calling-orchestration-schema": "static-1.37301",
      "trellis-story-utils": "static-1.4998",
      "storybook-react": "static-1.46",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16708",
      "browser-eslint": "static-2.57",
      "ContentData": "static-1.69604",
      "layout-data-lib": "static-1.10563",
      "academy-common-lib": "static-1.15538",
      "js-cookie": "static-1.18",
      "marketplace-ui-apps-core": "static-1.19599",
      "stripe-connect-js": "static-1.85",
      "ui-addon-react-router-dom": "static-1.10024",
      "meetings-client-types": "static-1.4089",
      "meetings-core": "static-1.801",
      "nested-table": "static-1.728",
      "customer-data-sidebar": "static-2.47050",
      "chatspot-widget-iframe": "static-1.24001",
      "collaboration-sidebar-common": "static-1.3904",
      "conditional-property-settings-data": "static-1.638",
      "trellis-ext-dnd": "static-1.578",
      "ui-addon-draggable-compat": "static-2.4760",
      "property-management-lib": "static-1.18203",
      "property-management-common": "static-1.6793",
      "d3": "static-1.7",
      "breeze-onboarding-components": "static-1.1109",
      "data-integrations-breeze": "static-1.375",
      "global-styles-ai-lib": "static-1.538",
      "marketplace-embed-ba": "static-1.945",
      "mermaid": "static-1.47",
      "reporting-action-components": "static-1.42452",
      "reporting-snowflake": "static-1.58051",
      "reporting-ui-components": "static-2.66704",
      "upgrade-components-lib": "static-1.756",
      "settings-ui-lib": "static-1.13027",
      "fail-safe": "static-1.448",
      "one-click-checkout": "static-1.777",
      "platform-infra-nav-components": "static-1.8014",
      "subscription-experience-data-types": "static-1.15469",
      "meetings-connect-utils-lib": "static-1.8119",
      "advanced-menus-core": "static-1.15853",
      "advanced-menus-lib": "static-1.12597",
      "ui-memberships-settings-lib": "static-1.35241",
      "academy-service-client": "static-1.4190",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4894",
      "trellis-ecosystem": "static-1.7885",
      "developer-experience-shared-components": "static-1.11041",
      "marketplace-ui-client-types": "static-1.18474",
      "marketplace-ui-common": "static-1.21067",
      "ui-addon-integrations-directory-panel": "static-2.8452",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.650",
      "card-payment-highlight-lib": "static-1.38363",
      "commerce-contract-lib": "static-1.13792",
      "invoices-highlight-card-lib": "static-1.56231",
      "orders-highlight-card-lib": "static-1.22539",
      "products-highlight-card-lib": "static-1.19253",
      "quotes-highlight-card-lib": "static-1.73123",
      "dnd-kit": "static-1.23",
      "audit-logs-shared-lib": "static-1.262",
      "data-quality-reports-lib": "static-1.10488",
      "data-quality-types-lib": "static-1.10495",
      "react-window-infinite-loader": "static-1.5",
      "smart-property-fill-lib": "static-1.730",
      "smart-property-lib": "static-1.8712",
      "onboarding-journeys-lib": "static-1.1277",
      "marketplace-embed": "static-1.23242",
      "marketplace-ui-install": "static-1.1053",
      "marketplace-ui-tracking": "static-1.15237",
      "dashboard-lib": "static-1.83362",
      "reporting-plugins": "static-1.11037",
      "share-with-third-party-component-lib": "static-1.9210",
      "reporting-reports": "static-1.69111",
      "bend-plugin-fail-safe": "static-1.399",
      "checkout-sdk": "static-3.24715",
      "payment-method-components": "static-1.7343",
      "touchless-buying-components": "static-1.6583",
      "upgrade-catalog-service-types": "static-1.3902",
      "edison-service-client-types": "static-1.890",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15852",
      "simple-menus-lib": "static-1.17369",
      "oauth-service-types": "static-1.4635",
      "ui-product-approvals-common": "static-1.1658",
      "products-ui-components": "static-1.41488",
      "reporting-enablement": "static-1.24232",
      "accounting-integrations-ui-components": "static-1.7834",
      "invoices-ui-lib": "static-1.56247",
      "commerce-products-api": "static-1.2962",
      "invoices-iframe-lib": "static-1.58305",
      "quotes-modal-lib": "static-1.103801",
      "quotes-ui-lib": "static-1.81844",
      "access-check-ui-lib": "static-1.1925",
      "data-agent-test-utils": "static-1.500",
      "data-agent-usage-based-billing": "static-1.143",
      "connections-embed-lib": "static-1.1791",
      "ai-studio-lib": "static-1.12814",
      "integrations-reconnect-lib": "static-1.764",
      "ui-product-approvals": "static-1.29763",
      "unified-auth": "static-1.1299",
      "redux-actions": "static-3.76",
      "campaign-roi-lib": "static-1.10882",
      "campaigns-utils-lib": "static-1.3749",
      "ui-addon-calendars": "static-2.5865",
      "hub-http-rxjs": "static-1.887",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4486",
      "company-details-components": "static-1.6705",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.16664",
      "quote-checkout-service-types": "static-1.3958",
      "commerce-tax-lib": "static-1.1052",
      "price-books-api": "static-1.2120",
      "price-books-components": "static-1.2178",
      "property-description-translator": "static-1.4319",
      "ramp-editor": "static-1.1255",
      "data-quality-ui-library": "static-1.14332",
      "report-customization-components": "static-1.14266",
      "reporting-filters": "static-1.1344",
      "reporting-insights-lib": "static-1.2975",
      "commerce-analytics-service-client": "static-1.4008",
      "totals-ui-components": "static-1.24599",
      "permissions-shared-i18n-strings-fe": "static-1.2145",
      "adobe-sign-auth-lib": "static-1.788",
      "ads-unified-auth-lib": "static-1.2116",
      "ai-mcp-auth-lib": "static-1.46",
      "gemini-settings-lib": "static-1.9824",
      "google-sheets-integration-lib": "static-1.1372",
      "microsoft-drive-auth-lib": "static-1.571",
      "slack-ui-library": "static-1.10898",
      "surveymonkey-integration-lib": "static-1.894",
      "copilot-messaging": "static-1.2443",
      "company-details-service-types": "static-1.4443",
      "pricing-pages-api": "static-1.16529",
      "line-items-api": "static-1.1372",
      "merge-modal-lib": "static-1.13089",
      "commerce-totals-service-types": "static-1.4147"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.31173",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.5208",
      "atom": "/atom/static-1.5570",
      "client-types": "/client-types/static-1.512",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9323",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16494",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13660",
      "conversations-message-history": "/conversations-message-history/static-1.13758",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10934",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.24536",
      "data-fetching-client": "/data-fetching-client/static-1.10137",
      "head-dlb": "/head-dlb/static-1.5330",
      "hs-promise-utils": "/hs-promise-utils/static-1.6090",
      "hs-test-utils": "/hs-test-utils/static-1.8537",
      "hubspot-dlb": "/hubspot-dlb/static-2.1911",
      "HubStyleTokens": "/HubStyleTokens/static-2.11985",
      "I18n": "/I18n/static-7.1715",
      "immer": "/immer/static-1.107",
      "jasmine-immutable": "/jasmine-immutable/static-1.3435",
      "jasmine-runner": "/jasmine-runner/static-1.6951",
      "quartz": "/quartz/static-1.7693",
      "react-dlb": "/react-dlb/static-1.96",
      "react-select-plus": "/react-select-plus/static-1.120",
      "react-transition-group": "/react-transition-group/static-2.80",
      "redux-thunk": "/redux-thunk/static-2.86",
      "reselect": "/reselect/static-3.18",
      "sanitize": "/sanitize/static-1.4971",
      "StyleGuideUI": "/StyleGuideUI/static-3.520",
      "transmute": "/transmute/static-2.97",
      "urlinator": "/urlinator/static-1.5012",
      "usage-tracker": "/usage-tracker/static-1.7821",
      "usage-tracker-core": "/usage-tracker-core/static-1.7671",
      "usage-tracker-public": "/usage-tracker-public/static-1.7632",
      "viral-links-lib": "/viral-links-lib/static-1.7582",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6656",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5315",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.23273",
      "cssUtils": "/cssUtils/static-1.1121",
      "enviro": "/enviro/static-4.523",
      "flux-actions": "/flux-actions/static-1.383",
      "foundations-components": "/foundations-components/static-1.8784",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6704",
      "interactive-cards": "/interactive-cards/static-1.579",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
      "immutable": "/immutable/static-2.88",
      "metrics-js": "/metrics-js/static-1.9990",
      "PatternValidationJS": "/PatternValidationJS/static-1.3381",
      "PortalIdParser": "/PortalIdParser/static-2.458",
      "pulse": "/pulse/static-1.1149",
      "raven": "/raven/static-3.6411",
      "react": "/react/static-7.204",
      "react-aria": "/react-aria/static-1.79",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.80",
      "react-rhumb": "/react-rhumb/static-1.17238",
      "react-utils": "/react-utils/static-2.5677",
      "redux": "/redux/static-4.81",
      "rpc-client-utils": "/rpc-client-utils/static-1.5165",
      "redux-toolkit": "/redux-toolkit/static-1.84",
      "sanitize-text": "/sanitize-text/static-1.8656",
      "signup-constants": "/signup-constants/static-1.19987",
      "styled-components": "/styled-components/static-2.100",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6235",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6467",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
      "raven-hubspot": "/raven-hubspot/static-1.6718",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1471",
      "quartz-core": "/quartz-core/static-1.6912",
      "foundations-assets": "/foundations-assets/static-1.5388",
      "foundations-theming": "/foundations-theming/static-1.4988",
      "UIComponents": "/UIComponents/static-3.8931",
      "conversations-async-data": "/conversations-async-data/static-2.8159",
      "customer-data-email": "/customer-data-email/static-1.18677",
      "cv-backend-services": "/cv-backend-services/static-1.1607",
      "immutable-less": "/immutable-less/static-1.5150",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7617",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.34516",
      "customer-data-objects": "/customer-data-objects/static-1.8208",
      "icons": "/icons/static-2.708",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1049",
      "ui-images": "/ui-images/static-2.1282",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.95",
      "HeadJS": "/HeadJS/static-2.829",
      "framer-motion": "/framer-motion/static-1.86",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3648",
      "msw": "/msw/static-1.105",
      "msw-config": "/msw-config/static-1.35",
      "testing-library": "/testing-library/static-1.167",
      "i18n-data": "/i18n-data/static-1.237",
      "moment-timezone": "/moment-timezone/static-5.98",
      "jasmine": "/jasmine/static-4.4804",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8536",
      "quartz-i18n": "/quartz-i18n/static-1.1368",
      "sassPrefix": "/sassPrefix/static-1.386",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5053",
      "floating-ui": "/floating-ui/static-1.70",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2704",
      "hs-story-utils": "/hs-story-utils/static-1.9927",
      "react-create-root-preference": "/react-create-root-preference/static-1.111",
      "react-virtualized": "/react-virtualized/static-2.114",
      "tanstack-table": "/tanstack-table/static-1.68",
      "trellis-assets": "/trellis-assets/static-1.3147",
      "ui-fonts": "/ui-fonts/static-1.1247",
      "hs-locale-management": "/hs-locale-management/static-1.414",
      "dompurify": "/dompurify/static-1.15",
      "utility-belt": "/utility-belt/static-1.3036",
      "batch-promise": "/batch-promise/static-1.2048",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.652",
      "chirp-fetch": "/chirp-fetch/static-1.2403",
      "event-emitter": "/event-emitter/static-1.1460",
      "fast-json-patch": "/fast-json-patch/static-1.76",
      "hub-http-janus": "/hub-http-janus/static-1.913",
      "quick-fetch": "/quick-fetch/static-1.4243",
      "csstype": "/csstype/static-1.50",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.198",
      "quartz-head": "/quartz-head/static-1.1358",
      "web-vitals": "/web-vitals/static-1.21",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.575",
      "quartz-routing": "/quartz-routing/static-1.1123",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6238",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.290",
      "dispatcher": "/dispatcher/static-1.150",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4987",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
      "module-federation": "/module-federation/static-1.42",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.665",
      "quartz-auth": "/quartz-auth/static-1.1368",
      "quartz-test": "/quartz-test/static-1.1368",
      "quartz-tracking": "/quartz-tracking/static-1.1072",
      "trellis-components": "/trellis-components/static-1.3166",
      "usage-tracker-container": "/usage-tracker-container/static-1.7811",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3471",
      "foundations-theming-base": "/foundations-theming-base/static-1.3973",
      "stylex": "/stylex/static-1.48",
      "HubStyle": "/HubStyle/static-2.12292",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5087",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10330",
      "FileManagerCore": "/FileManagerCore/static-1.40377",
      "FileManagerLib": "/FileManagerLib/static-1.40518",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5381",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.756",
      "timezone-utils": "/timezone-utils/static-2.5729",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
      "ts-schema": "/ts-schema/static-1.4407",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.10064",
      "avatar-components": "/avatar-components/static-1.2987",
      "content-assistance-lib": "/content-assistance-lib/static-1.8455",
      "crm-component-utils": "/crm-component-utils/static-1.40250",
      "crm-display-components": "/crm-display-components/static-1.26000",
      "crm-fe-perf": "/crm-fe-perf/static-1.23398",
      "crm-links": "/crm-links/static-1.6812",
      "crm-message-bus": "/crm-message-bus/static-1.44153",
      "crm-search-service-types": "/crm-search-service-types/static-1.1631",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5829",
      "customer-data-communicator": "/customer-data-communicator/static-1.46664",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41439",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13534",
      "customer-data-properties": "/customer-data-properties/static-1.53125",
      "customer-data-rte": "/customer-data-rte/static-1.33939",
      "draft-plugins": "/draft-plugins/static-2.22394",
      "file-manager-components": "/file-manager-components/static-1.24878",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7392",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8420",
      "hs-resources": "/hs-resources/static-1.683",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19321",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11680",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1465",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8612",
      "trellis-theming": "/trellis-theming/static-1.1515",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18561",
      "universal-associations-select": "/universal-associations-select/static-1.11596",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2411",
      "wootric-nps": "/wootric-nps/static-1.7310",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4163",
      "property-translator": "/property-translator/static-1.5879",
      "segments-query-core": "/segments-query-core/static-1.1929",
      "bender-build-tools": "/bender-build-tools/static-1.3615",
      "stylex-utils": "/stylex-utils/static-1.182",
      "opentelemetry-web": "/opentelemetry-web/static-1.25",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10940",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10938",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5507",
      "base-ui": "/base-ui/static-1.31",
      "react-day-picker": "/react-day-picker/static-1.17",
      "tanstack-virtual": "/tanstack-virtual/static-1.45",
      "react-dnd-compat": "/react-dnd-compat/static-1.5109",
      "audio-components": "/audio-components/static-1.6605",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1063",
      "ContentUtils": "/ContentUtils/static-1.69529",
      "copilot-toolkit": "/copilot-toolkit/static-1.12193",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.30094",
      "FileManagerImages": "/FileManagerImages/static-1.38029",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1809",
      "html-to-image": "/html-to-image/static-1.67",
      "immerable": "/immerable/static-1.4641",
      "react-colorpicker": "/react-colorpicker/static-2.10708",
      "ui-universal-auth": "/ui-universal-auth/static-1.9785",
      "video-components": "/video-components/static-1.14489",
      "video-data-lib": "/video-data-lib/static-1.36145",
      "video-embed": "/video-embed/static-1.36979",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.840",
      "chatspot-core": "/chatspot-core/static-1.24010",
      "trellis-migration-context": "/trellis-migration-context/static-1.77",
      "superstore": "/superstore/static-1.5256",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9122",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29607",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38096",
      "crm-actions": "/crm-actions/static-1.6884",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.45072",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10267",
      "customer-data-tracking": "/customer-data-tracking/static-1.7371",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3787",
      "framework-data-table": "/framework-data-table/static-2.12878",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10465",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2078",
      "calling-error-reporting": "/calling-error-reporting/static-1.31828",
      "calling-internal-common": "/calling-internal-common/static-1.31821",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.7039",
      "crm_data": "/crm_data/static-4.93253",
      "customer-data-content": "/customer-data-content/static-1.28077",
      "draft-content-plugins": "/draft-content-plugins/static-1.29194",
      "draft-convert": "/draft-convert/static-2.86",
      "draft-extend": "/draft-extend/static-3.90",
      "draft-js": "/draft-js/static-5.92",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24919",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25286",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19313",
      "integration-settings-components": "/integration-settings-components/static-1.16520",
      "integrations-lib": "/integrations-lib/static-1.17480",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6122",
      "laboratory-lib": "/laboratory-lib/static-3.7645",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8261",
      "nav-meta": "/nav-meta/static-1.30853",
      "onboarding-scopes": "/onboarding-scopes/static-1.6952",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12644",
      "quotes-client-types": "/quotes-client-types/static-1.39213",
      "reference-resolvers": "/reference-resolvers/static-1.8683",
      "rich-text-lib": "/rich-text-lib/static-1.20590",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4347",
      "sequences-lib": "/sequences-lib/static-1.8823",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11644",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9578",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9596",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10779",
      "user-context": "/user-context/static-1.5553",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.7211",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23874",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8551",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13673",
      "events-data-lib": "/events-data-lib/static-1.746",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5213",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4348",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1511",
      "onboarding-tours": "/onboarding-tours/static-1.17423",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14809",
      "segments-client-types": "/segments-client-types/static-1.12253",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
      "ui-addon-teams": "/ui-addon-teams/static-1.22038",
      "calling-global-api": "/calling-global-api/static-1.66268",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67650",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59942",
      "commerce-products-lib": "/commerce-products-lib/static-1.10970",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4126",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4789",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4456",
      "data-agent-utils": "/data-agent-utils/static-1.969",
      "data-token-picker": "/data-token-picker/static-1.17170",
      "external-options-client-types": "/external-options-client-types/static-1.4451",
      "formula-editor": "/formula-editor/static-1.15041",
      "google-libphonenumber": "/google-libphonenumber/static-1.52",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4527",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1130",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.4021",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.50102",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4296",
      "property-value-citations": "/property-value-citations/static-1.3739",
      "react-tinymce": "/react-tinymce/static-1.56313",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.530",
      "tiered-pricing": "/tiered-pricing/static-1.2321",
      "tinymce-config": "/tinymce-config/static-2.55439",
      "tinymce-plugins": "/tinymce-plugins/static-1.58553",
      "tinymce-themes": "/tinymce-themes/static-1.57409",
      "topics-actions-lib": "/topics-actions-lib/static-1.683",
      "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1422",
      "trial-components-library": "/trial-components-library/static-1.14423",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10363",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
      "zustand": "/zustand/static-1.91",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.2255",
      "poll-commands": "/poll-commands/static-1.3976",
      "video-components-external": "/video-components-external/static-1.12487",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.511",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7297",
      "persist-promise": "/persist-promise/static-1.4205",
      "content-media-capture": "/content-media-capture/static-1.5831",
      "emoji-mart": "/emoji-mart/static-3.9",
      "growth-payments-core": "/growth-payments-core/static-1.26544",
      "knowledge-content-types": "/knowledge-content-types/static-1.8767",
      "payment-link-components": "/payment-link-components/static-1.24503",
      "call-summary": "/call-summary/static-1.40956",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11086",
      "merchandise-lib": "/merchandise-lib/static-1.288",
      "purchase-motions-components": "/purchase-motions-components/static-1.6664",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10499",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "breeze-engine-core": "/breeze-engine-core/static-1.1533",
      "cms-field-types": "/cms-field-types/static-1.5309",
      "content-icons-ui": "/content-icons-ui/static-1.2480",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5928",
      "magpie-types": "/magpie-types/static-1.5388",
      "simple-logging-lib": "/simple-logging-lib/static-1.3550",
      "nudge-client-utils": "/nudge-client-utils/static-1.3454",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.349",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1581",
      "social-insights-client-types": "/social-insights-client-types/static-1.22970",
      "outpost": "/outpost/static-1.4628",
      "markdown-it": "/markdown-it/static-1.6",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7080",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20534",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19617",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11363",
      "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47793",
      "customer-data-associations": "/customer-data-associations/static-1.7837",
      "reporting-data": "/reporting-data/static-1.69435",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.476",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5250",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3874",
      "crm_universal": "/crm_universal/static-1.22760",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9771",
      "content-embed-lib": "/content-embed-lib/static-1.7843",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13539",
      "remote-dom": "/remote-dom/static-1.11",
      "remote-ui": "/remote-ui/static-1.78",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.6122",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.18301",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3512",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14895",
      "redux-observable": "/redux-observable/static-1.81",
      "ReduxMessenger": "/ReduxMessenger/static-2.10869",
      "rxjs": "/rxjs/static-5.10",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.9276",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8680",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6267",
      "navigation-messaging": "/navigation-messaging/static-1.8543",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19604",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18722",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1490",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7405",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2362",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.10370",
      "growth-data-modal": "/growth-data-modal/static-1.6168",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3557",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3025",
      "navigation-components": "/navigation-components/static-1.19216",
      "nest": "/nest/static-1.735",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5638",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8160",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6947",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11542",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2524",
      "commerce-permissions": "/commerce-permissions/static-1.1286",
      "products-iframe-lib": "/products-iframe-lib/static-1.8958",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11322",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11023",
      "sales-views-client-types": "/sales-views-client-types/static-1.4757",
      "data-agent-kit": "/data-agent-kit/static-1.956",
      "enrichment-settings-lib": "/enrichment-settings-lib/static-1.290",
      "fsm": "/fsm/static-1.4256",
      "policy-lib": "/policy-lib/static-1.7303",
      "bark-lib": "/bark-lib/static-1.17033",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.108",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6396",
      "react-codemirror": "/react-codemirror/static-1.11141",
      "tinymce": "/tinymce/static-5.11",
      "hub-http-contrib": "/hub-http-contrib/static-1.3531",
      "interframe": "/interframe/static-3.5241",
      "tinymce-data": "/tinymce-data/static-1.41524",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5701",
      "layout-dnd-components": "/layout-dnd-components/static-1.13263",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.12238",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17002",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9380",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.16077",
      "hubs-service-types": "/hubs-service-types/static-1.1766",
      "purchase-motions-api": "/purchase-motions-api/static-1.6667",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1233",
      "highlight.js": "/highlight.js/static-1.92",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13635",
      "content-media-compositions": "/content-media-compositions/static-2.17642",
      "idb-keyval": "/idb-keyval/static-1.57",
      "media-bridge-lib": "/media-bridge-lib/static-1.19676",
      "fix-webm-duration": "/fix-webm-duration/static-1.36",
      "notification-sounds": "/notification-sounds/static-1.4928",
      "seat-types-lib": "/seat-types-lib/static-1.1086",
      "ui-addon-opt": "/ui-addon-opt/static-4.8916",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6895",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5582",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4020",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19802",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9707",
      "custom-summary-templates": "/custom-summary-templates/static-1.159",
      "reactive-lib": "/reactive-lib/static-1.1219",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3211",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3530",
      "whisper-core-api": "/whisper-core-api/static-1.7675",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24277",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8283",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6571",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15881",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5605",
      "qrcode-generator": "/qrcode-generator/static-1.82",
      "meetings-rte-lib": "/meetings-rte-lib/static-1.579",
      "reporting-client-types": "/reporting-client-types/static-1.2858",
      "react-flip-move": "/react-flip-move/static-1.85",
      "FireAlarmUi": "/FireAlarmUi/static-1.4888",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4496",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11601",
      "apps-service-types": "/apps-service-types/static-1.4108",
      "association-settings-lib": "/association-settings-lib/static-1.11343",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.59107",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.620",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13531",
      "data-model-actions-lib": "/data-model-actions-lib/static-1.1961",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13720",
      "ExportDialog": "/ExportDialog/static-6.10872",
      "final-form": "/final-form/static-1.85",
      "property-management-iframe": "/property-management-iframe/static-1.14505",
      "property-usages-lib": "/property-usages-lib/static-1.6033",
      "reactflow": "/reactflow/static-1.78",
      "simple-data-table": "/simple-data-table/static-1.3859",
      "used-in-list-lib": "/used-in-list-lib/static-1.7476",
      "visual-association": "/visual-association/static-1.6400",
      "highcharts": "/highcharts/static-8.117",
      "reporting-visualizations": "/reporting-visualizations/static-1.61509",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4413",
      "crm-record-cards-client": "/crm-record-cards-client/static-1.101",
      "ai-rendering-library": "/ai-rendering-library/static-1.11444",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8628",
      "breeze-engine-ui-devtools": "/breeze-engine-ui-devtools/static-1.629",
      "copilot-plugins": "/copilot-plugins/static-1.12165",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1811",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1981",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10844",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.701",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4418",
      "ui-tool-access": "/ui-tool-access/static-1.10657",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2871",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3053",
      "user-context-client": "/user-context-client/static-1.5008",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37301",
      "trellis-story-utils": "/trellis-story-utils/static-1.4998",
      "storybook-react": "/storybook-react/static-1.46",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16708",
      "browser-eslint": "/browser-eslint/static-2.57",
      "ContentData": "/ContentData/static-1.69604",
      "layout-data-lib": "/layout-data-lib/static-1.10563",
      "academy-common-lib": "/academy-common-lib/static-1.15538",
      "js-cookie": "/js-cookie/static-1.18",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19599",
      "stripe-connect-js": "/stripe-connect-js/static-1.85",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10024",
      "meetings-client-types": "/meetings-client-types/static-1.4089",
      "meetings-core": "/meetings-core/static-1.801",
      "nested-table": "/nested-table/static-1.728",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.47050",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24001",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3904",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.638",
      "trellis-ext-dnd": "/trellis-ext-dnd/static-1.578",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4760",
      "property-management-lib": "/property-management-lib/static-1.18203",
      "property-management-common": "/property-management-common/static-1.6793",
      "d3": "/d3/static-1.7",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1109",
      "data-integrations-breeze": "/data-integrations-breeze/static-1.375",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.538",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.945",
      "mermaid": "/mermaid/static-1.47",
      "reporting-action-components": "/reporting-action-components/static-1.42452",
      "reporting-snowflake": "/reporting-snowflake/static-1.58051",
      "reporting-ui-components": "/reporting-ui-components/static-2.66704",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.756",
      "settings-ui-lib": "/settings-ui-lib/static-1.13027",
      "fail-safe": "/fail-safe/static-1.448",
      "one-click-checkout": "/one-click-checkout/static-1.777",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8014",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15469",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8119",
      "advanced-menus-core": "/advanced-menus-core/static-1.15853",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12597",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35241",
      "academy-service-client": "/academy-service-client/static-1.4190",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4894",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7885",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11041",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18474",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.21067",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8452",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.650",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38363",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13792",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56231",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22539",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19253",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.73123",
      "dnd-kit": "/dnd-kit/static-1.23",
      "audit-logs-shared-lib": "/audit-logs-shared-lib/static-1.262",
      "data-quality-reports-lib": "/data-quality-reports-lib/static-1.10488",
      "data-quality-types-lib": "/data-quality-types-lib/static-1.10495",
      "react-window-infinite-loader": "/react-window-infinite-loader/static-1.5",
      "smart-property-fill-lib": "/smart-property-fill-lib/static-1.730",
      "smart-property-lib": "/smart-property-lib/static-1.8712",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1277",
      "marketplace-embed": "/marketplace-embed/static-1.23242",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.1053",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15237",
      "dashboard-lib": "/dashboard-lib/static-1.83362",
      "reporting-plugins": "/reporting-plugins/static-1.11037",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9210",
      "reporting-reports": "/reporting-reports/static-1.69111",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.399",
      "checkout-sdk": "/checkout-sdk/static-3.24715",
      "payment-method-components": "/payment-method-components/static-1.7343",
      "touchless-buying-components": "/touchless-buying-components/static-1.6583",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
      "edison-service-client-types": "/edison-service-client-types/static-1.890",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15852",
      "simple-menus-lib": "/simple-menus-lib/static-1.17369",
      "oauth-service-types": "/oauth-service-types/static-1.4635",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1658",
      "products-ui-components": "/products-ui-components/static-1.41488",
      "reporting-enablement": "/reporting-enablement/static-1.24232",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7834",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.56247",
      "commerce-products-api": "/commerce-products-api/static-1.2962",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58305",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103801",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81844",
      "access-check-ui-lib": "/access-check-ui-lib/static-1.1925",
      "data-agent-test-utils": "/data-agent-test-utils/static-1.500",
      "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.143",
      "connections-embed-lib": "/connections-embed-lib/static-1.1791",
      "ai-studio-lib": "/ai-studio-lib/static-1.12814",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.764",
      "ui-product-approvals": "/ui-product-approvals/static-1.29763",
      "unified-auth": "/unified-auth/static-1.1299",
      "redux-actions": "/redux-actions/static-3.76",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10882",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3749",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5865",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.887",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4486",
      "company-details-components": "/company-details-components/static-1.6705",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16664",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3958",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.1052",
      "price-books-api": "/price-books-api/static-1.2120",
      "price-books-components": "/price-books-components/static-1.2178",
      "property-description-translator": "/property-description-translator/static-1.4319",
      "ramp-editor": "/ramp-editor/static-1.1255",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.14332",
      "report-customization-components": "/report-customization-components/static-1.14266",
      "reporting-filters": "/reporting-filters/static-1.1344",
      "reporting-insights-lib": "/reporting-insights-lib/static-1.2975",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.4008",
      "totals-ui-components": "/totals-ui-components/static-1.24599",
      "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2116",
      "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.46",
      "gemini-settings-lib": "/gemini-settings-lib/static-1.9824",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1372",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
      "slack-ui-library": "/slack-ui-library/static-1.10898",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.894",
      "copilot-messaging": "/copilot-messaging/static-1.2443",
      "company-details-service-types": "/company-details-service-types/static-1.4443",
      "pricing-pages-api": "/pricing-pages-api/static-1.16529",
      "line-items-api": "/line-items-api/static-1.1372",
      "merge-modal-lib": "/merge-modal-lib/static-1.13089",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4147"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.31173",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};